export function createWorker() {
    return new Worker(new URL("./computed_min_max.ts", import.meta.url), {
        type: "module",
    })
}
